import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useCallback, useRef } from 'react';

export const PluginInfoList = () => {

  const rsrc = useRsrc();
  const entityListRef = useRef();
  const module = useModuleFromRoute();

  const activateOrDeactivate = useCallback((entityObj) => {
    const active = entityObj.status === 'ACTIVE'
    entityObj.status = active ? 'INACTIVE' : 'ACTIVE';
    rsrc.save(module, 'PLUGIN_INFO', entityObj);
  }, [module, rsrc]);

  const getContextMenuItems = useCallback((params) => {
    let contextMenus = entityListRef.current.getContextMenuItems(params);
    const active = params.node.data.status === 'ACTIVE';
    contextMenus.push(
      {
        name: active ? 'Deactivate' : 'Activate',
        action: () => activateOrDeactivate(params.node.data),
        icon: active ? '<span class = "fa fa-check"></span>' : '<span class = "fa fa-times"></span>'
      }
    );
    return contextMenus;
  }, [entityListRef, activateOrDeactivate]);

  return (
    <EntityList
      entity="PLUGIN_INFO"
      ref={entityListRef}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}
